import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/home" // 👈 Now redirects to the new Home page
  },
  {
    path: "/auth/login",
    name: "Login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/sizing",
    name: "Sizing",
    component: () => import("../views/SizingView.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },

  {
    path: "/projects",
    name: "projects",
    component: () => import("../views/ProjectView.vue"),
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// ✅ Global Auth Guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('_token');

  if (to.path !== '/auth/login' && !token) {
    next('/auth/login'); // 🔒 Block access if not authenticated
  } else {
    next(); // ✅ Proceed to route
  }
});

export default router;
